import {
  getReceiptsSettings as publicGetReceiptsSettings,
  updateReceiptsSettings as publicUpdateReceiptsSettings,
} from './receipts-v1-receipts-settings-receipts-settings.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onReceiptsSettingsUpdated as publicOnReceiptsSettingsUpdated } from './receipts-v1-receipts-settings-receipts-settings.public.js';

export const getReceiptsSettings: MaybeContext<
  BuildRESTFunction<typeof publicGetReceiptsSettings> &
    typeof publicGetReceiptsSettings
> = /*#__PURE__*/ createRESTModule(publicGetReceiptsSettings);
export const updateReceiptsSettings: MaybeContext<
  BuildRESTFunction<typeof publicUpdateReceiptsSettings> &
    typeof publicUpdateReceiptsSettings
> = /*#__PURE__*/ createRESTModule(publicUpdateReceiptsSettings);
/**
 * Triggered when a site's receipt settings are updated. [TEST]
 */
export const onReceiptsSettingsUpdated: BuildEventDefinition<
  typeof publicOnReceiptsSettingsUpdated
> &
  typeof publicOnReceiptsSettingsUpdated = /*#__PURE__*/ createEventModule(
  publicOnReceiptsSettingsUpdated
);

export { WebhookIdentityType } from './receipts-v1-receipts-settings-receipts-settings.universal.js';
export {
  ReceiptsSettings,
  Numbering,
  ExtendedFields,
  GetReceiptsSettingsRequest,
  GetReceiptsSettingsResponse,
  UpdateReceiptsSettingsRequest,
  UpdateReceiptsSettingsResponse,
  NextNumberDescendingErrorDetails,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  ReceiptsSettingsUpdatedEnvelope,
} from './receipts-v1-receipts-settings-receipts-settings.universal.js';
export {
  WebhookIdentityTypeWithLiterals,
  GetReceiptsSettingsApplicationErrors,
  UpdateReceiptsSettingsApplicationErrors,
} from './receipts-v1-receipts-settings-receipts-settings.universal.js';
